import React from 'react';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
interface BlogCardProps {
  image: string;
  date: string;
  title: string;
  excerpt: string;
  link?: string;
}
export function BlogCard({
  image,
  date,
  title,
  excerpt,
  link
}: BlogCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-340">
      <div className="h-48 overflow-hidden" data-id="element-341">
        <img src={image} alt={title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" data-id="element-342" />
      </div>
      <div className="p-6" data-id="element-343">
        <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-344">
          <CalendarIcon className="h-4 w-4 mr-2" data-id="element-345" />
          {date}
        </div>
        <h3 className="text-xl font-bold text-[#0B1F3A] mb-3" data-id="element-346">{title}</h3>
        <p className="text-gray-600 mb-4" data-id="element-347">{excerpt}</p>
        {link && <a href={link} className="inline-flex items-center text-[#E63946] font-semibold hover:text-[#D32F2F] transition-colors" data-id="element-348">
            Read More
            <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-349" />
          </a>}
      </div>
    </div>;
}